import z from 'zod';

export const productDataSchema = z.object({
  id: z.string().uuid({ message: 'Invalid product ID format' }),
  displayName: z.string(),
  productAlias: z.string(),
  shortDescription: z.string(),
  description: z.string(),
  salesPrice: z.number(),
  commissionAmount: z.number(),
  commissionIsPercent: z.boolean().default(false),
  category: z.string(),
});

export type ProductData = z.infer<typeof productDataSchema>;
